module.exports = __webpack_public_path__ + "static/media/inc_outside_india_fisdom.064e4678.svg";